<!-- 阶梯价格表 -->
<template>
  <transition name="el-zoom-in-top">
    <div>
      <!-- 4/6层板爆款提示 -->
      <!-- 隐藏六层板惊爆价 -->
      <p v-if="hotFlag && hotFlag != 2" class="ladder-price__tips hot">
        <i></i>
        <template v-if="hotFlag == 3">
          {{ tips }}
        </template>
        <!-- <template v-else-if="hotFlag == 2">
          六层板惊爆价￥580/㎡，板材费<span>直降10%</span>
        </template> -->
        <template v-else-if="hotFlag == 1">
          四层板惊爆价￥400/㎡
        </template>
      </p>
      <p v-else-if="tips" class="ladder-price__tips">
        <i></i>
        {{ tips }}
      </p>
      <div class="ladder-price">
        <el-table 
          border 
          v-loading="loading"
          class="ladder-price__table"
          :data="list" 
          :cell-class-name="cellClassName"
        >
          <template v-for="(item, index) in tableHead">
            <el-table-column 
              v-if="index === 0"
              align="center" 
              label="板厚/价格" 
              width="100"
              class-name="ladder-price__table__firstColumn"
              label-class-name="ladder-price__table__firstCell"
            >
              <template slot="header" slot-scope="scope">
                <div class="ladder-price__table__bias">
                    <div class="top">面积</div>
                    <div class="bottom">板厚</div>
                  </div>
              </template>
              <div slot-scope="{ row }">
                {{ (row[index] || {}).showTitle }}
              </div>
            </el-table-column>
            <el-table-column 
              v-else
              align="center"
              :label="item.showTitle"
            >
              <div slot-scope="{ row }">
                {{ (row[index] || {}).showTitle }}
              </div>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </transition>
</template>

<script>
import { debounce } from '@@/utils/utils'
import { getPriceList } from '@@/api/pcb'

export default {
  props: {
    // 获取阶梯价参数
    ladderPriceData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      tableHead: [],
      list: [],
      tips: '',
      hotFlag: '', // 1: 4层板爆款提示 2: 6层板爆款提示
      debounceGetPirce: debounce(this.getList, 300), // 接口防抖
    }
  },
  watch: {
    ladderPriceData(newVal, oldVal) {
      const hasChange = Object.keys(newVal).some(key => newVal[key] != oldVal[key])
      if (hasChange) {
        this.debounceGetPirce()
      }
    }
  },
  mounted() {
    this.debounceGetPirce()
  },
  methods: {
    getList() {
      this.loading = true
      getPriceList(this.ladderPriceData)
        .then(res => {
          if (!res) return
          const data = res.data || {}
          const { tableHead, showList, tips, hotFlag } = data
          this.tableHead = tableHead || []
          this.list = showList || []
          this.tips = (tips || [])[0]
          this.hotFlag = hotFlag
          this.$emit('tipsChange', this.tips)
          this.$emit('change', this.list)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 当前/最惠class
    cellClassName({ row, column, rowIndex, columnIndex }) {
      const { now, max, hot, bgcolor } = row[columnIndex] || {}
      // 背景颜色
      let bgClass = bgcolor ? `bgcolor_${bgcolor}` : ''
      // 当前标识class
      if (now) return `ladder-price__table__icon now ${bgClass}`
      // 最惠标识class
      if (max) return `ladder-price__table__icon max ${bgClass}`
      // 爆款标识class
      if (hot) return `ladder-price__table__icon hot ${bgClass}`
      return bgClass || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.ladder-price__tips {
  margin-bottom: 8px;
  padding-left: 125px;
  font-size: 12px;
  >i {
    margin-right: 4px;
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: bottom;
    background: url(~@@/assets/img/icons/icon_minus.png);
  }
  &.hot {
    >i {
      width: 20px;
      height: 16px;
      vertical-align: bottom;
      background: url(~@@/assets/img/icons/icon_drop.png);
    }
    >span {
      color: #E7001D;
    }
  }
}
.ladder-price {
  margin: 0 20px 18px;
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #EBEEF5;
  .ladder-price__table {
    font-size: 13px;
    ::v-deep {
      td, th {
        padding: 4px 0;
        font-weight: 400;
        color: #666666;
        >.cell {
          padding-left: 0;
          padding-right: 0;
        }
      }
      th,
      .ladder-price__table__firstColumn {
        background-color: #F5F7FA !important;
      }
      .ladder-price__table__firstCell.is-leaf {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
        &::before {
          content: "";
          position: absolute;
          top: 1px;
          left: 0;
          display: block;
          width: 1px;
          height: 110px;
          background-color: #EBEEF5;
          transform: rotate(-73deg);
          transform-origin: top;
        }
      }
      .ladder-price__table__icon {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          display: block;
          width: 26px;
          height: 16px;
        }
        &.now::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_now.png);
        }
        &.max::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_max.png);
        }
        &.hot::after {
          background: url(~@@/assets/img/icons/icon_ladder_price_hot.png);
        }
        &.max {
          color: #F65001;
        }
      }
      .bgcolor_red {
        background-color: #FFF7F8;
      }
    }
    
    .ladder-price__table__bias {
      line-height: 1;
      font-size: 12px;
      .top {
        text-align: right;
        box-sizing: border-box;
      }
      .bottom {
        text-align: left;
        box-sizing: border-box;
      }
    }
  }
}
</style>